<template>
  <div id="hres78u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres78uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :detailTab3Table="columns[dash.nowLang].detailTab3Table"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres78u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>

    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :postHres78uSendApprove="postHres78uSendApprove" 
            :detail="detail"
            :detailSubmit="detailSubmit"
            :arrTypintr="dropdowns.typintr"
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :showTrailRepayment="showTrailRepayment"
            :showProcessTable="showProcessTable"
            :showPersonaldata="showPersonaldata"
            :setShowTrailRepayment="setShowTrailRepayment"
            :setShowProcessTable="setShowProcessTable"
            :setShowPersonaldata="setShowPersonaldata"
            :trailRepayment="trailRepayment"
            :columnsProcessTable="columns[dash.nowLang].columnsProcessTable"
            :tableProcess="tableProcess"
            :datapersonal="datapersonal"
            :receivedHres78uDetailSubmit="receivedHres78uDetailSubmit"
            :receivedHres78uPopupTrailRepayment="receivedHres78uPopupTrailRepayment"
            :receivedHres78uPopupProcessTable="receivedHres78uPopupProcessTable"
            :receivedHres78uPopupPersonaldata="receivedHres78uPopupPersonaldata"
            :searchParams="searchParams" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres78u/mutation-types'
import detail from 'components/hres78u/detail'
import popupApprove from 'components/hres78u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres78u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve',
      searchParams: {}
    }
  },
  created () {
    this.receivedHres78uColumnsLabels()
    this.receivedHres78uIndex()
    this.receivedHres78uDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES78U_INDEX_DISP,
      detailDisp: types.GET_HRES78U_DETAIL_DISP,
      columns: types.GET_HRES78U_COLUMNS,
      labels: types.GET_HRES78U_LABELS,
      index: types.GET_HRES78U_INDEX,
      indexSelected: types.GET_HRES78U_INDEX_SELECTED,
      detail: types.GET_HRES78U_DETAIL,
      detailSubmit: types.GET_HRES78U_DETAIL_SUBMIT,
      dropdowns: types.GET_HRES78U_DROPDOWNS,
      trailRepayment: types.GET_HRES78U_POPUP_TRAILREPAYMENT,
      tableProcess: types.GET_HRES78U_POPUP_PROCESSTABLE,
      datapersonal: types.GET_HRES78U_POPUP_PERSONALDATA,
      showTrailRepayment: types.GET_HRES78U_SHOW_TRAILREPAYMENT,
      showProcessTable: types.GET_HRES78U_SHOW_PROCESSTABLE,
      showPersonaldata: types.GET_HRES78U_SHOW_PERSONALDATA
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres78uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setShowTrailRepayment(false)
        this.setShowProcessTable(false)
        this.setShowPersonaldata(false)
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres78uDetail(this.indexSelected)
        this.receivedHres78uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES78U_INDEX_SELECTED,
      setShowTrailRepayment: types.SET_HRES78U_SHOW_TRAILREPAYMENT,
      setShowProcessTable: types.SET_HRES78U_SHOW_PROCESSTABLE,
      setShowPersonaldata: types.SET_HRES78U_SHOW_PERSONALDATA
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES78U_PAGE,
      receivedHres78uColumnsLabels: types.RECEIVED_HRES78U_COLUMNS_LABELS,
      receivedHres78uIndex: types.RECEIVED_HRES78U_INDEX,
      receivedHres78uDetail: types.RECEIVED_HRES78U_DETAIL,
      receivedHres78uDetailSubmit: types.RECEIVED_HRES78U_DETAIL_SUBMIT,
      postHres78uSendApprove: types.POST_HRES78U_SEND_APPROVE,
      receivedHres78uDropdowns: types.RECEIVED_HRES78U_DROPDOWNS,
      receivedHres78uPopupTrailRepayment: types.RECEIVED_HRES78U_POPUP_TRAILREPAYMENT,
      receivedHres78uPopupProcessTable: types.RECEIVED_HRES78U_POPUP_PROCESSTABLE,
      receivedHres78uPopupPersonaldata: types.RECEIVED_HRES78U_POPUP_PERSONALDATA
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?ffdb3492